[].slice.call(document.querySelectorAll('.image-cards-container figure[tabindex="0"], .image-cards-container button.arrow')).forEach(function(el) {
	el.addEventListener('click', function() {
		openVideoModal(el);
	});
});

function openVideoModal(el) {
	var parent = el.closest('li'),
		videoCaption = parent.querySelector('p'),
		videoModalCaption = videoModal.querySelector('p');

	setVideo(parent);

	if(parent.querySelector('h3')) videoModal.querySelector('h2').innerHTML = parent.querySelector('h3').innerHTML;

	if(videoCaption) {
		if(videoModalCaption)
			videoModalCaption.innerHTML = videoCaption.innerHTML;
		else {
			videoModalCaption = document.createElement('p');
			videoModalCaption.innerHTML = videoCaption.innerHTML;
			videoModal.querySelector('.content').appendChild(videoModalCaption);
		}
	}
	else if(videoModalCaption)
		videoModal.querySelector('.content').removeChild(videoModalCaption);

	Velocity(videoModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

	videoModal.querySelector('.close-modal').focus();

	skipLinkToggleDisplay(true);

	setFocus(true, false);
}

function setVideo(parent) {
	var video,
		src = parent.dataset.video;

	if(src.indexOf(location.host) == -1) {
		video = document.createElement('iframe');

		video.src = src+'?autoplay=1&rel=0';
		video.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
		video.setAttribute('allowfullscreen', 'true');
	}
	else {
		video = document.createElement('video');

		video.src = src;
		video.autoplay = true;
		video.controls = true;
	}

	videoModal.querySelector('.video-container').appendChild(video);
}

document.addEventListener('keydown', function(e) {
	var activeElement = document.activeElement;

	if(e.key == 'Enter' && activeElement.classList.contains('bg-wrapper') && activeElement.getAttribute('aria-role') == 'button')
		openVideoModal(activeElement);
});